import { jsxs as e, jsx as a, Fragment as N } from "react/jsx-runtime";
import { R as b, b as y, P as x, O, C as R, T as D, D as I, a as s } from "./index-oo5hbrXN.js";
import { R as M } from "./index-CQ-GaoeM.js";
import { c as l } from "./clsx-OuTLNxxd.js";
import { B as $ } from "./button.types-CKCCdr7D.js";
import { Divider as w } from "./components/elements/divider/divider.js";
import { I as B } from "./icon-CEddREfQ.js";
import "./components/elements/icon/iconsList.js";
import { StepperDots as P } from "./components/elements/stepperDots/stepperDots.js";
const T = "_modal_jckcw_29", o = {
  "modal-overlay": "_modal-overlay_jckcw_29",
  "dialog-overlay-show": "_dialog-overlay-show_jckcw_1",
  modal: T,
  "dialog-content-slide-up": "_dialog-content-slide-up_jckcw_1",
  "dialog-content-show": "_dialog-content-show_jckcw_1",
  "is-small": "_is-small_jckcw_67",
  "is-medium": "_is-medium_jckcw_70",
  "is-large": "_is-large_jckcw_73",
  "modal-title": "_modal-title_jckcw_81",
  "is-closable": "_is-closable_jckcw_98",
  "modal-divider": "_modal-divider_jckcw_102",
  "modal-bottom": "_modal-bottom_jckcw_105",
  "outer-modal-content": "_outer-modal-content_jckcw_109",
  "modal-content": "_modal-content_jckcw_118",
  "modal-actions": "_modal-actions_jckcw_131",
  "no-dividers": "_no-dividers_jckcw_141",
  "confirm-cta": "_confirm-cta_jckcw_144",
  "no-alternative-action": "_no-alternative-action_jckcw_147",
  "alternative-cta": "_alternative-cta_jckcw_150",
  "alternative-cta-multi": "_alternative-cta-multi_jckcw_153",
  "modal-close": "_modal-close_jckcw_164"
};
function U({
  size: j = "medium",
  title: k,
  description: d,
  onClose: n,
  children: v,
  dialogTriggerNode: u,
  alternativeAction: t,
  confirmActionText: m,
  onConfirmAction: g,
  onAlternativeAction: f,
  isOpen: p,
  onChange: _,
  areDividersVisible: i = !0,
  isClosable: h = !0,
  multiSteps: c
}) {
  const C = l(o.modal, o[z[j]]);
  return /* @__PURE__ */ e(b, { open: p, onOpenChange: (r) => {
    _ && _(r), r === !1 && n && n(r);
  }, children: [
    /* @__PURE__ */ a(y, { asChild: !0, children: u }),
    /* @__PURE__ */ e(x, { children: [
      /* @__PURE__ */ a(O, { className: o["modal-overlay"] }),
      /* @__PURE__ */ e(R, { className: C, children: [
        /* @__PURE__ */ e("div", { children: [
          /* @__PURE__ */ a(D, { className: l(o["modal-title"], h && o["is-closable"]), children: k }),
          d && /* @__PURE__ */ a(M, { asChild: !0, children: /* @__PURE__ */ a(I, { children: d }) })
        ] }),
        i && /* @__PURE__ */ a(w, { className: o["modal-divider"] }),
        /* @__PURE__ */ a("div", { className: o["outer-modal-content"], children: /* @__PURE__ */ a("div", { className: o["modal-content"], children: v }) }),
        m && /* @__PURE__ */ e(N, { children: [
          i && /* @__PURE__ */ a(w, { className: `${o["modal-divider"]} ${o["modal-bottom"]}` }),
          /* @__PURE__ */ e("div", { className: l(o["modal-actions"], !i && o["no-dividers"]), children: [
            t && /* @__PURE__ */ a(s, { asChild: !0, children: /* @__PURE__ */ a(
              "button",
              {
                className: l(
                  o["alternative-cta"],
                  (c == null ? void 0 : c.currentStep) === 0 && o["alternative-cta-multi"]
                ),
                onClick: f,
                children: t
              }
            ) }),
            c && /* @__PURE__ */ a(P, { currentStep: c.currentStep, stepsCount: c.stepNumber }),
            /* @__PURE__ */ a(s, { asChild: !0, children: /* @__PURE__ */ a(
              $,
              {
                onClick: g,
                className: l(o["confirm-cta"], !t && o["no-alternative-action"]),
                text: m
              }
            ) })
          ] })
        ] }),
        h && /* @__PURE__ */ a(s, { asChild: !0, children: /* @__PURE__ */ a("button", { className: o["modal-close"], "aria-label": "Close", children: /* @__PURE__ */ a(B, { name: "remove", size: "large" }) }) })
      ] })
    ] })
  ] });
}
const z = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
};
export {
  U as M,
  z as a
};
